<script>
    export let title = ''
    import { Typography, Button } from '../UI'
    import { createEventDispatcher } from 'svelte'
    import { solveAccents } from '$lib/utils'
    export let preview = false
    export let replace = false
    export let download = true
    export let config = {}
    import Docs from '../Icons/custom/Docs.svelte'
    import { Download, ShowEye, Edit } from '../Icons/custom/'
    const dispatch = createEventDispatcher()
    function onPreview() {
        dispatch('preview')
    }
    function onDownload() {
        dispatch('download')
    }
    function onReplace() {
        dispatch('replace')
    }
    $: _conf = {
        ...{
            replace: { label: 'Editar', icon: Edit },
            preview: { label: 'Ver', icon: ShowEye },
            download: {},
        },
        ...config,
    }
</script>

<span class="item">
    <div
        style="display: flex; flex-direction: row; align-items: center; gap: 12px"
    >
        <Docs />
        <!-- <Typography type="subtitle" style="width: 50%; margin: 24px 0 -10px 0;padding: 0;" color="grey-800">{title}</Typography> -->
        <!-- <Typography type="subtitle" style="width: 50%; margin: 0;padding: 0;" color="grey-800">Hello</Typography> -->
        <Typography type="h5">{solveAccents(title)}</Typography>
        <!-- <InputText/> -->
    </div>
    <div class="options">
        {#if replace}
            <Button
                style="padding: 5px 15px; gap: 8px; min-width: 0px"
                label={_conf.replace.label}
                size="small"
                on:click={onReplace}
            >
                {#if _conf.replace.icon}
                    <svelte:component
                        this={_conf.replace.icon}
                        color="white"
                        style="cursor: pointer"
                    />
                {/if}
                <!-- <Edit color="white" style="cursor: pointer"/> -->
            </Button>
            <!-- <div title="Previsualizar" on:click={onPreview}>
            </div> -->
        {/if}
        {#if preview}
            <Button
                style="padding: 5px 15px; gap: 8px; min-width: 0px"
                label={_conf.preview.label}
                size="small"
                on:click={onPreview}
            >
                {#if _conf.preview.icon}
                    <svelte:component
                        this={_conf.preview.icon}
                        color="white"
                        style="cursor: pointer"
                    />
                {/if}
                <!-- <ShowEye color="white" style="cursor: pointer"/> -->
            </Button>
            <!-- <div title="Previsualizar" on:click={onPreview}>
            </div> -->
        {/if}
        <!-- <div title="Descargar PDF" on:click={_ => {
            window.open(link, '_blank')
        }}> -->
        {#if download}
            <div title="Descargar PDF" on:click={onDownload}>
                <Download style="cursor: pointer" />
            </div>
        {/if}
    </div>
</span>

<style>
    span {
        min-height: 72px;
        height: auto;
        position: relative;
        width: 100%;
        font-family: Roboto;
        display: flex;
    }
    span.item {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        border-bottom: 1px var(--color-grey-300) solid;
    }
    .options {
        display: flex;
        flex-direction: row;
        gap: 25px;
        align-items: center;
    }
</style>
